const logs = {
    page_title: 'گزارش‌های ممیزی',
    title: 'گزارش‌های ممیزی',
    subtitle: 'داده‌های گزارش رویدادهای احراز هویت انجام‌شده توسط کاربران خود را مشاهده کنید',
    event: 'رویداد',
    user: 'کاربر',
    application: 'برنامه',
    time: 'زمان',
    filter_by: 'فیلتر بر اساس',
    last_1_hour: '۱ ساعت گذشته',
    last_24_hours: '۲۴ ساعت گذشته',
    last_7_days: '۷ روز گذشته',
    last_30_days: '۳۰ روز گذشته',
    custom_range: 'بازه سفارشی',
    from: 'از',
    to: 'تا',
};
export default Object.freeze(logs);
